export default class ArchiveActionModel {
  constructor(ArchiveNumber, ArchiveData, UserGuid, SecondaryId, CreatedBy) {
    this.ArchiveNumber = ArchiveNumber === undefined ? 0 : ArchiveNumber;
    this.ArchiveData = ArchiveData === undefined ? "" : ArchiveData;
    this.UserGuid = UserGuid === undefined ? 0 : UserGuid;
    this.SecondaryId = SecondaryId === undefined ? 0 : SecondaryId;
    this.CreatedBy = CreatedBy === undefined ? 0 : CreatedBy;
  }
}
